// Sentinel `orderId` that puts `OrderEditor` into create-mode (a new jízda) rather
// than fetch-by-id. Shared by every site that opens the editor for a new record
// (OrdersPage, the calendar) and the editor itself — they MUST agree on the exact
// value, so it lives in one place. See ADR-0052 (in-place editor over the calendar).
export const NEW_ORDER_ID = '__new__';
